<template>
  <div>
    <div class="custom-control custom-checkbox">
      <input type="checkbox" class="custom-control-input" :id="id" v-model="actualValue" :disabled="disabled">
      <label class="custom-control-label text-large" :for="id">{{this.label}}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Checkbox',
  props: ['id', 'label', 'value', 'disabled'],
  computed: {
    actualValue: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('valueChanged', newValue, this.id)
      }
    }
  }
}
</script>

<style scoped>
.custom-control {
  margin-bottom: 0;
  position: relative;
  display: block;
  min-height: 1.5rem;
  padding-left: 2rem;
}
.custom-control-input[disabled],
.custom-control-input:disabled,
.custom-control-input {
  position: absolute;
  left: 0;
  z-index: -1;
  width: 1.5rem;
  height: 1.5rem;
  opacity: 0;
}
.custom-control-label {
  font-weight: 600;
  text-align: left;
  width: 50px;
  line-height: 1.5;
  margin-right: 24px;
  margin-bottom: 0;
  display: block;
  position: relative;
  cursor: pointer;
  user-select: none;
}

.custom-control-label::after {
  position: absolute;
  top: 0rem;
  left: -2rem;
  display: block;
  width: 1.5rem;
  height: 1.5rem;
  content: "";
  background: no-repeat 50% / 1rem 1rem;
  border: 1px solid #6B7280;
  border-radius: 6px;
  background-image: url(data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' fill-rule='evenodd' stroke='#{$blue-dark}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 8L6.125 12 14 4'/></svg>);
  filter: invert(1);
}

.custom-control-input[disabled] ~ .custom-control-label,
.custom-control-input:disabled ~ .custom-control-label {
  color: #000;
  opacity: 0.5;
}

.custom-control-input:checked ~ .custom-control-label {
  &:after {
    background-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' fill-rule='evenodd' stroke='white' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 8L6.125 12 14 4'/></svg>");
  }
}

@media only screen and (max-width: 600px) {
  .custom-control-label {
    margin-right: -5px;
  }
}
@media only screen and (max-width: 280px) {
  .custom-control-label {
    margin-right: -14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Checkbox.vue